module.exports = __webpack_public_path__ + "img/img6.56830d43.png";